var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgWhiteRoundLeftLineArrow = function SvgWhiteRoundLeftLineArrow(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 48,
    viewBox: "0 0 47 48",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbol_608",
    "data-name": "Symbol 608",
    transform: "translate(-258 -352)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Symbol_517",
    "data-name": "Symbol 517",
    transform: "translate(258 352)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1667",
    "data-name": "Group 1667"
  }, /*#__PURE__*/React.createElement("g", {
    id: "group-66"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "ellipse-17",
    cx: 23.5,
    cy: 24,
    rx: 23.5,
    ry: 24,
    fill: "#f0f0f0"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "noun_685132_cc",
    transform: "translate(293.167 366.656) rotate(90)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1668",
    "data-name": "Group 1668",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1622",
    "data-name": "Path 1622",
    d: "M8.983,23.459l-8.822-8.3a.533.533,0,0,1-.024-.738.546.546,0,0,1,.738-.024l7.947,7.476V.519a.519.519,0,0,1,1.038,0v21.35l7.947-7.476a.542.542,0,0,1,.738.024.527.527,0,0,1-.024.738L9.7,23.459a.557.557,0,0,1-.714,0Z",
    fill: "#07a3c8"
  }))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWhiteRoundLeftLineArrow, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/whiteRoundLeftLineArrow.1869fefb.svg";
export { ForwardRef as ReactComponent };